import { render, staticRenderFns } from "./filter-category-selector.vue?vue&type=template&id=f4dc018c&"
import script from "./filter-category-selector.vue?vue&type=script&lang=js&"
export * from "./filter-category-selector.vue?vue&type=script&lang=js&"
import style0 from "./filter-category-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports